import { useMutation, useQuery } from '@tanstack/react-query'

import { useAppSelector } from '@/stores/hooks.ts'
import { operationRequestsSelectors } from '@/stores/slices/operation-requests-slice.ts'

import { CreateOperationRequestParams, OperationRequest, TableData } from '../types.ts'

import { apiService } from './root.ts'

export const OPERATION_REQUEST_ROOT = '/acq-operation-requests'

export const OPERATION_REQUESTS_ENDPOINTS = {
  root: OPERATION_REQUEST_ROOT,
  item: (id: string) => `${OPERATION_REQUEST_ROOT}/${id}`,
  sendUrl: `${OPERATION_REQUEST_ROOT}/sendUrl`,
}

export const useGetOperationRequests = () => {
  const { page, showCount } = useAppSelector(operationRequestsSelectors.filters)

  return useQuery({
    queryKey: ['operation_requests', { page, showCount }],
    queryFn: () =>
      apiService.get<TableData<OperationRequest>>(OPERATION_REQUESTS_ENDPOINTS.root, {
        queryParams: { page, showCount },
      }),
  })
}

export const useMutateCreateOperationRequest = () =>
  useMutation({
    mutationFn: (bodyParams: CreateOperationRequestParams) =>
      apiService.post(OPERATION_REQUESTS_ENDPOINTS.root, { bodyParams }),
  })
